@switch (getState()) {
@case ('loading') {
<groundworks-card>
  <groundworks-card-body>
    <groundworks-state-message type="loading" message="Loading Customer..." class="d-flex" />
  </groundworks-card-body>
</groundworks-card>
}
@case ('no-matches') {
<groundworks-card>
  <groundworks-card-body>
    <groundworks-state-message type="no-matches" message="No Customer Found." class="d-flex" />
  </groundworks-card-body>
</groundworks-card>
}
@case ('error') {
<groundworks-card>
  <groundworks-card-body>
    <groundworks-state-message type="error" message="Error loading Customer." class="d-flex" />
  </groundworks-card-body>
</groundworks-card>
}
@case ('matches') {
<groundworks-customer-card [customerName]="customerName()" [customerId]="customerIdText()"
  [customerLabel]="'CUSTOMER SINCE'" [customerValue]="customerSinceText()" [address]="addressText()"
  [phone]="phone()" [email]="email()" [opportunities]="opportunityItems()" (addressClicked)="onAddressClick()"
/>
}
}
